import { combineTokens } from '@utils/css';

const tokens = combineTokens("--video23-component", {
  aspectRatio: "56.25%"
});
const PLAYER_ENTER_TRANSITION_DURATION_MS = 200;
const playerContainer = "_vcpy1z4de";
const player = "_vcp1mb1nuj";

export { PLAYER_ENTER_TRANSITION_DURATION_MS, player, playerContainer, tokens };
import "./atom.video23.style.linaria.module.css";
//# sourceMappingURL=atom.video23.style.js.map
